import PostbackActions from '../../../../actions/PostbackActions';

export const actions = {
    getListPostbacks(id) {
        PostbackActions.getListPostbacks({
            ids: id
        });
    }
};
